import { z } from "zod/mini"

import { getTableRowSchema } from "./legacy/table"
import { RichTextContentSchema } from "./richText"

export const TableContentType = "TableContent" as const

// Table
export const TableContentSchema = z.object({
	__TYPE__: z.literal(TableContentType),
	content: z.array(getTableRowSchema(RichTextContentSchema)),
})

export type TableContent = z.infer<typeof TableContentSchema>
